import { Hero } from "@/components/Hero";
import { RouteBridge } from "@/components/RouteBridge";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Logistics } from "@/components/Logistics";
import { MovingSection } from "@/components/MovingSection";
import { Configurator } from "@/components/Configurator";
import { WhyUs } from "@/components/WhyUs";
import { Process } from "@/components/Process";
import { Areas } from "@/components/Areas";
import { About } from "@/components/About";
import { QuoteCta } from "@/components/QuoteCta";
import { Contact } from "@/components/Contact";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <RouteBridge />
      <Marquee />
      <Services />
      <Logistics />
      <MovingSection />
      <Configurator />
      <WhyUs />
      <Process />
      <Areas />
      <About />
      <QuoteCta />
      <Contact />
    </main>
  );
}
